import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext } from 'react'
import GlobalPageHeaderText from '../../components/utility/globalPageHeaderText'
import globalStyles from "../../assets/styles/global.module.scss";
import headerStyles from '../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import styles from "../../assets/styles/componentStyles/conversionLeadsStyles/conversionLeadsStyle.module.scss";
import { useConversionLeadStore } from '../../store/conversionLeadStore';
import { useShallow } from 'zustand/react/shallow';
import { UserContext, UserContextPayload } from '../../context/userContext';
import ConversionLeadTable from './components/conversionLeadTable';

const ConversionLeadsGlobal = () => {
    
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { getLeadOrdersApi } = useConversionLeadStore(useShallow((state) => ({
        getLeadOrdersApi: state.getLeadOrdersApi
    })))


    const getLeadOrdersApiCall = async (limit: number, offset: number, flagUpdate: boolean) => {
        const cacheKey = `${limit}-${offset}`;
        const isCached = Boolean(useConversionLeadStore.getState().leadOrdersPageCache[cacheKey]) && !flagUpdate;

        if (!isCached) {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        }

        const res = await getLeadOrdersApi(limit, offset, flagUpdate);

        if (!isCached) {
            if (!(res?.status)) {
                handleError(res);
            }
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container sx={{ padding: { xs: "15px 0px", sm: "23px 0px" } }} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={globalStyles.fullwidth} sx={{ padding: { xs: "0px 20px", lg: "5px 25px 0px 27px" } }}>
                                <GlobalPageHeaderText
                                    mainHeadText={"Conversion Leads"}
                                    flagMainTextOnly
                                />
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${styles.pageDivider}`} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} className={styles.pageOutlet}>
                        <ConversionLeadTable
                            getLeadOrdersApiCall={getLeadOrdersApiCall}
                        />
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default ConversionLeadsGlobal
